import "promise-polyfill/src/polyfill";
import objectFitImages from "object-fit-images";
import swiper from "./swiper";
import countdown from "./countdown";
import smoothScroll from "./smooth-scroll";
import header from "./header";
import heroSearch from "./hero-search";
import headerSearch from "./header-search";
import lightbox from "./lightbox";
import freeform from "./freeform";
// import your components here
// import SampleButton from "keplerstein-component-library/sample-button";

objectFitImages(null, { watchMQ: true });
swiper();
countdown();
smoothScroll();
header();
heroSearch();
headerSearch();
lightbox();
freeform();
// use your imported components here
// SampleButton();
